import { gql } from "@apollo/client";export default gql`mutation deleteConcept($id: Int!) {
    deleteConcept: delete_concept_by_pk(id: $id) {
        id
    }
}
`;
